import React, { useContext, useEffect, useState } from "react";
import CardOrdenDigital from "_+_Portal/components/Turnos/CardOrdenDigital/CardOrdenDigital";
import ToasterV2 from "../../../global/component/Genericos/Toaster/ToasterV2";
import { GlobalContext } from "../../../global/context/Provider";
import { displayAyuda, displayAyudaMobile } from "../../../global/utils/ayuda";
import BotonSubir from "../../assets/images/generico/BotonSubir";
import BurguerMobile from "../../components/Genericos/BurguerMobile/BurguerMobile";
import HeaderbarHome from "../../components/Genericos/HeaderbarHome/HeaderbarHome";
import Sidebar from "../../components/Genericos/Sidebar/Sidebar";
import { hideAyuda } from "../../context/Actions/ayuda/ayuda";
import { PortalContext } from "../../context/Provider";
import "./OrdenesDigitales.css";
import {
  resetLabOrdenDigital,
  setLoadingOrdenDigital,
  wsGetLabOrdenDigital,
} from "_+_Portal/context/Actions/labOrdenDigital/labOrdenDigital";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import { editaTurnosDisponibles } from "_+_Portal/context/Actions/turnos/turnosDisponibles";

import { useHistory } from "react-router";
import {
  setBuscarTurnoLabo,
  setFlgCambiarTurno,
} from "_+_Portal/context/Actions/turnos/laboTurnos";
import {
  LimpiarSelectGlobal,
  SelectUserGlobal,
} from "_+_Portal/context/Actions/DropDownFamiliares/selectFamiliares";
import { showModal } from "_+_Portal/context/Actions/modal/modal";
import Modal from "_+_Portal/components/Genericos/Modal/Modal";
import TurnoNoEncontrado from "_+_Portal/components/Genericos/TurnoNoEcontrado/TurnoNoEncontrado";
import { wsGetOrdenDigitalEstudio } from "_+_Portal/context/Actions/ordenDigital/ordenDigital";
import { showToaster } from "global/context/action/toaster/toaster";
import InformacionIcon from "_+_Portal/assets/images/generico/InformacionIcon";
import BtnVolver from "_+_Portal/components/Genericos/BtnVolver/BtnVolver";
import FloatingScroll from "_+_Portal/components/Genericos/FloatingScroll/FloatingScroll";
import { motion } from "framer-motion";
import {
  container,
  dots,
  pageContainerVariants,
} from "global/utils/cardAnimation";
import HeaderTitle from "_+_Portal/components/Genericos/HeaderTitle/HeaderTitle";

const OrdenesDigitales = () => {
  //#region --------- context --------------
  const {
    turnosPacienteState,
    ayudaDispatch,
    labOrdenDigitalDispatch,
    labOrdenDigitalState,
    ordenDigitalDispatch,
    ordenDigitalState,
    laboTurnosState,
    turnosDisponiblesState,
    laboGrupoState,
    turnosDisponiblesDispatch,
    laboTurnosDispatch,
    selectDropDownDispatch,
    selectDropDownState,
    listaFamiliaresState,
    modalDispatch,
    modalState,
    pdfOrdenDigitalState,
  } = useContext(PortalContext);
  const { authState, toasterState, toasterDispatch } =
    useContext(GlobalContext);
  //#endregion ------ context --------------

  //#region -------- constantes --------------
  const [showBurguerMobile, setShowBurguerMobile] = useState(false);
  const [listaOrdenes, setListaOrdenes] = useState(null);

  const widthWindow = window.innerWidth;
  const esMobile = widthWindow <= 768;

  let centrosLabo =
    turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData.centrosLabo;

  const history = useHistory();

  //#endregion ------ constantes --------------

  //#region --------- funciones --------------
  const onShowBurguerHandle = () => {
    setShowBurguerMobile(true);
  };
  const onCloseBurguerMobile = (type) => {
    if (type === "open") setShowBurguerMobile(true);
    else setShowBurguerMobile(false);
  };

  const onChangeFamiliar = (e) => {
    if (e !== "") {
      if (e.familiar && e.manejoTurnos) {
        wsGetLabOrdenDigital(e.id)(labOrdenDigitalDispatch);
        wsGetOrdenDigitalEstudio(e.id)(ordenDigitalDispatch);
        SelectUserGlobal({ id: e.id, paciente: e.paciente })(
          selectDropDownDispatch,
        );
      } else if (!e.manejoTurnos && e.familiar) {
        // Modal que te dice que no estás autorizado
        showModal(
          "Perfil/ModalAlertGrupoFamiliar/ModalAlertGrupoFamiliar",
          {},
          "centro",
        )(modalDispatch);
        // setDropDownValue(false);
        wsGetLabOrdenDigital(-1)(labOrdenDigitalDispatch);
        wsGetOrdenDigitalEstudio(authState.auth.data.paciente.codigo)(
          ordenDigitalDispatch,
        );
        LimpiarSelectGlobal()(selectDropDownDispatch);
      } else {
        // setDropDownValue(false);
        wsGetLabOrdenDigital(-1)(labOrdenDigitalDispatch);
      }
    } else {
      LimpiarSelectGlobal()(selectDropDownDispatch);
    }
  };

  const onClickBuscarTurnos = () => {
    history.push("/consultamedica");
  };

  const limpiarOrdenes = () => {
    resetLabOrdenDigital()(labOrdenDigitalDispatch);
  };

  //#endregion ------ funciones --------------

  //#region -------- useEffect --------------

  useEffect(() => {
    //este time out es porque la libreria no escucha los cambios muy rapido
    setTimeout(() => {
      hideAyuda()(ayudaDispatch);
      displayAyuda("hidden");
      displayAyudaMobile("hidden");
    }, 250);
    const pacienteElegido =
      selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id;
    wsGetLabOrdenDigital(pacienteElegido ? pacienteElegido : -1)(
      labOrdenDigitalDispatch,
    );
    wsGetOrdenDigitalEstudio(
      pacienteElegido ? pacienteElegido : authState.auth.data.paciente.codigo,
    )(ordenDigitalDispatch);

    //obtener centros para busqueda de turnos de labo
    let auxC = localStorage.getItem("laboCentros");
    let laboCentros = JSON.parse(auxC);
    if (laboCentros !== null && laboCentros !== undefined) {
      if (
        turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
          .centrosLabo !== undefined
      ) {
        if (
          turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
            .centrosLabo.length === 1
        ) {
          let centrosLabo =
            turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
              .centrosLabo;
          let centro = [
            ...new Set(laboCentros.map((item) => item.descripcion)),
          ];
          let ubicacion = [
            ...new Set(laboCentros.map((item) => item.ubicacion)),
          ];
          let coordenadas = [
            ...new Set(laboCentros.map((item) => item.coordenadaGps)),
          ];
          const map = new Map();
          for (const item of centro) {
            for (const itemUbi of ubicacion) {
              for (const itemGps of coordenadas) {
                if (
                  !centrosLabo.filter(
                    (x) =>
                      x.descripcion === item &&
                      x.ubicacion === itemUbi &&
                      x.coordenadas === itemGps,
                  ).length > 0
                ) {
                  if (
                    !map.has(item) &&
                    !map.has(itemUbi) &&
                    !map.has(itemGps)
                  ) {
                    map.set(item);
                    map.set(itemUbi);
                    map.set(itemGps);
                    //para colocar correctamente los id. tomo el ultimo item de la lista. cuyo id + 1.
                    const lastItem = centrosLabo[centrosLabo.length - 1];
                    centrosLabo.push({
                      id: lastItem.id + 1,
                      descripcion: item,
                      ubicacion: itemUbi,
                      coordenadas: itemGps,
                      checked: true,
                    });
                  }
                }
              }
            }
          }
          // guardo los centros
          editaTurnosDisponibles({
            ...turnosDisponiblesState.turnosDisponibles.turnosData,
            filtrosData: {
              ...turnosDisponiblesState.turnosDisponibles.turnosData
                .filtrosData,
              centrosLabo: centrosLabo,
            },
          })(turnosDisponiblesDispatch);
        }
      }
    } else {
    }
    setFlgCambiarTurno(false)(laboTurnosDispatch);
    setBuscarTurnoLabo(false)(laboTurnosDispatch);
  }, []);

  useEffect(() => {
    if (
      laboTurnosState.laboTurnos.data &&
      centrosLabo.length > 0 &&
      laboTurnosState.laboTurnos.flgBuscarTurno
    ) {
      let descEstudio = "TURNO DE LABORATORIO GENERAL";
      editaTurnosDisponibles({
        ...turnosDisponiblesState.turnosDisponibles.turnosData,
        turnos: laboTurnosState.laboTurnos.data.data,
        grupoMedico: 5,
        particular: false,
        idEstudio: 5,
        descEstudio: descEstudio,
        descEspecialidad: null,
        fechaBusqueda: laboTurnosState.laboTurnos.data.fechaBusqueda,
        dtoBusqueda: { idGrupo: 5 },
        volverOrigen: "LABORATORIO",
        proceso: "labo",
        filtrosData: {
          ...turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData,
          centrosLabo,
        },
      })(turnosDisponiblesDispatch);
      setLoadingOrdenDigital(false)(labOrdenDigitalDispatch);
      history.push("/turnosDisponibles");
    }
  }, [
    laboTurnosState.laboTurnos.data,
    centrosLabo,
    laboTurnosState.laboTurnos.flgBuscarTurno,
  ]);

  useEffect(() => {
    if (
      labOrdenDigitalState.labOrdenDigital.data &&
      ordenDigitalState.ordenDigital.data
    ) {
      // Laboratorio: ocultar cuando IdEstado === 9
      const ordenesLab = Array.isArray(labOrdenDigitalState.labOrdenDigital.data)
        ? labOrdenDigitalState.labOrdenDigital.data.filter(
            (item) => item.idEstado !== 9
          )
        : labOrdenDigitalState.labOrdenDigital.data;
      // Estudio (his/ordenes-digitales/misOrdenes): ocultar cuando ATENDIDO === true
      const ordenesEstudios = Array.isArray(
        ordenDigitalState.ordenDigital.data
      )
        ? ordenDigitalState.ordenDigital.data.filter(
            (item) => item.atendido !== true
          )
        : ordenDigitalState.ordenDigital.data;
      const ordenArrx = (Array.isArray(ordenesLab) ? ordenesLab : []).concat(
        Array.isArray(ordenesEstudios) ? ordenesEstudios : []
      );
      const ordenByFecha = ordenArrx.sort((a, b) => {
        const fechaA = a.fechaAlta || a.fechaalta;
        const fechaB = b.fechaAlta || b.fechaalta;
        return new Date(fechaB).getTime() - new Date(fechaA).getTime();
      });
      setListaOrdenes(ordenByFecha);
    }
  }, [
    labOrdenDigitalState.labOrdenDigital.data,
    ordenDigitalState.ordenDigital.data,
  ]);

  useEffect(() => {
    if (
      labOrdenDigitalState.labOrdenDigital.error !== null ||
      ordenDigitalState.ordenDigital.error !== null
    ) {
      showToaster(
        {
          texto:
            labOrdenDigitalState.labOrdenDigital.error !== null
              ? labOrdenDigitalState?.labOrdenDigital?.error?.detail?.Message
              : ordenDigitalState?.ordenDigital?.error !== null
                ? ordenDigitalState?.ordenDigital?.error?.detail?.Message
                : "Error al obtener orden médica",
          tipo: "danger",
        },
        "centroArriba",
      )(toasterDispatch);
    }
  }, [
    labOrdenDigitalState.labOrdenDigital.error,
    ordenDigitalState.ordenDigital.error,
  ]);

  //#endregion ------ useEffect --------------

  return (
    <React.Fragment>
      {modalState.modal.show && <Modal />}
      {toasterState.toaster.show && <ToasterV2 />}
      <Loading
        dataLoading={
          labOrdenDigitalState.labOrdenDigital.loading ||
          ordenDigitalState.ordenDigital.loading ||
          ordenDigitalState.ordenDigital.loadPdf ||
          laboTurnosState.laboTurnos.loading ||
          laboGrupoState.laboGrupo.loading ||
          turnosDisponiblesState.turnosDisponibles.loading ||
          labOrdenDigitalState.labOrdenDigital.load ||
          listaFamiliaresState.listaFamiliares.loading ||
          pdfOrdenDigitalState.pdfOrdenDigital.loading
        }
        color={"c-white"}
        descripcion={"Cargando..."}
      />

      <BurguerMobile
        onCloseBurguerMobile={onCloseBurguerMobile}
        showBurguerMobile={showBurguerMobile}
        nextFnc={limpiarOrdenes}
      />
      <HeaderbarHome onShowBurguerHandle={onShowBurguerHandle} />
      <HeaderTitle title={"Órdenes Digitales"} />

      <div className="ptur-bodyContainer-ordenesdigitales">
        <div className="ptur-mainSidebar">
          <Sidebar nextFnc={limpiarOrdenes} />
        </div>
        {/* <BtnVolver to="/autocheckin" label="Volver" /> */}
        <motion.div
          variants={pageContainerVariants(esMobile)}
          initial="hidden"
          animate="visible"
          exit="exit"
          className={"ptur-ordenesdigitales-boxGrid"}
        >
          <p className="rb24b ptur-ordenesdigitales-tituloPagina">
            Visualiza, descargá y compartí tus órdenes médicas
          </p>
          <hr className="ptur-ordenesdigitales-lineaSeparadora" />
          <div className="ptur-ordenesdigitales-body">
            {listaOrdenes?.length <= 0 && (
              <div style={{ marginTop: 50 }}>
                <TurnoNoEncontrado
                  state={listaOrdenes}
                  loadingState={
                    labOrdenDigitalState.labOrdenDigital ||
                    ordenDigitalState.ordenDigital
                  }
                  texto={"No se encuentran órdenes digitales pendientes"}
                  recomendacion={""}
                  txtBtn="Buscar un turno"
                  onClickTurnos={onClickBuscarTurnos}
                  showBtn={false}
                />
              </div>
            )}

            <motion.ul
              key={listaOrdenes?.length}
              className="ptur-ordenesdigitales-cards"
              variants={container(0.1)}
              initial="hidden"
              animate="visible"
            >
              {Array.isArray(listaOrdenes) ? (
                listaOrdenes.map((item, index) => (
                  <motion.li
                    key={item.id}
                    className="itemCardOrdenes"
                    variants={dots()}
                  >
                    <div key={index}>
                      <CardOrdenDigital data={item} />
                    </div>
                  </motion.li>
                ))
              ) : (
                <div className="ptur-turnoNoEncontrado-noEcontrados-container">
                  <div className="ptur-turnoNoEncontrado-noEcontrados-icono">
                    <InformacionIcon />
                  </div>
                  <div className="ptur-turnoNoEncontrado-noEcontrados-texto">
                    <div className="ptur-turnoNoEncontrado-noEcontrados-texto">
                      <p className="rb16l">
                        No contiene Ordenes digitales disponibles
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </motion.ul>
            {turnosPacienteState.turnosPaciente.loading ? (
              ""
            ) : (
              // <div className="ptur-ordenesdigitales-botonSubir">
              //   <BotonSubir body={"ptur-ordenesdigitales-body"} />
              // </div>
              <FloatingScroll body={"ptur-ordenesdigitales-body"} />
            )}
          </div>
        </motion.div>
      </div>
    </React.Fragment>
  );
};
export default OrdenesDigitales;
